// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool-card-wrapper {
    position: relative;
    width: 100%;
    max-width: 320px;
    min-height: 320px;
    border-radius: 18px;
    background: rgba(255, 251, 230, 0.95);
    padding: 20px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1), 
                0 8px 15px rgba(0, 0, 0, 0.05),
                0 1px 3px rgba(220, 202, 152, 0.3);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    transform-style: preserve-3d;
    margin: 0 auto;
  }
  
  .tool-card-wrapper:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.14), 
                0 10px 20px rgba(0, 0, 0, 0.08),
                0 2px 5px rgba(220, 202, 152, 0.4);
  }
  
  .tool-card-wrapper::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: linear-gradient(90deg, #114040, #dcca98);
    border-radius: 18px 18px 0 0;
    opacity: 0.8;
  }
  
  .tool-card-front {
    z-index: 1;
    position: relative;
    padding: 10px 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
  }
  
  /* Icon container with background */
  .icon-container {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    transition: transform 0.5s ease;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);
  }
  
  .tool-card-wrapper:hover .icon-container {
    transform: scale(1.1) translateY(-5px);
  }
  
  .tool-icon {
    width: 85px;
    height: 85px;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
    transition: transform 0.5s ease;
  }
  
  .tool-card-front h3 {
    font-size: 1.5rem;
    color: #114040;
    margin-bottom: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
    position: relative;
    display: inline-block;
  }
  
  .tool-card-front h3::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -6px;
    width: 40px;
    height: 2px;
    background: #dcca98;
    transform: translateX(-50%);
    transition: width 0.3s ease;
  }
  
  .tool-card-wrapper:hover .tool-card-front h3::after {
    width: 80px;
  }
  
  .tool-card-front p {
    font-size: 1rem;
    color: #333;
    margin-top: 8px;
    line-height: 1.5;
    flex-grow: 1;
  }
  
  /* Learn more text */
  .learn-more {
    display: inline-block;
    color: #114040;
    font-size: 0.9rem;
    font-weight: 600;
    margin-top: 15px;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
    border-bottom: 1px dotted #dcca98;
    padding-bottom: 2px;
  }
  
  .tool-card-wrapper:hover .learn-more {
    opacity: 1;
    transform: translateY(0);
  }
  
  /* Hover overlay */
  .tool-card-preview {
    position: absolute;
    inset: 0;
    z-index: 2;
    padding: 20px;
    background: rgba(255, 255, 255, 0.98);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.35s cubic-bezier(0.23, 1, 0.32, 1);
    border-radius: 18px;
    flex-direction: column;
  }
  
  /* Preview overlay with button */
  .preview-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    background: linear-gradient(to top, rgba(255, 255, 255, 0.9) 70%, rgba(255, 255, 255, 0));
    display: flex;
    justify-content: center;
  }
  
  .preview-button {
    background: linear-gradient(90deg, #114040, #195e5e);
    color: #dcca98;
    border: none;
    padding: 10px 20px;
    border-radius: 30px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.5px;
  }
  
  .preview-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
    background: linear-gradient(90deg, #195e5e, #114040);
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.96); }
    to   { opacity: 1; transform: scale(1); }
  }
  
  /* Responsive styles */
  @media (max-width: 1200px) {
    .tool-card-wrapper {
      max-width: 100%;
    }
  }
  
  @media (max-width: 991px) {
    .tool-card-wrapper {
      min-height: 300px;
      padding: 25px 20px;
    }
    
    .icon-container {
      width: 100px;
      height: 100px;
      margin-bottom: 1.2rem;
    }
    
    .tool-icon {
      width: 75px;
      height: 75px;
    }
    
    .tool-card-front h3 {
      font-size: 1.4rem;
      margin-bottom: 10px;
    }
    
    .tool-card-front p {
      font-size: 0.95rem;
    }
    
    .preview-button {
      padding: 8px 18px;
      font-size: 0.95rem;
    }
  }
  
  @media (max-width: 767px) {
    .tool-card-wrapper {
      max-width: 100%;
      min-height: 280px;
      margin: 0 auto;
    }
    
    /* Make hover effects show on touch for mobile */
    .tool-card-front .learn-more {
      opacity: 1;
      transform: translateY(0);
    }
    
    /* Adjust hover effects for touch devices */
    .tool-card-wrapper:hover {
      transform: translateY(-5px) scale(1.01);
    }
    
    .tool-card-wrapper:hover .icon-container {
      transform: scale(1.05) translateY(-3px);
    }
  }
  
  @media (max-width: 600px) {
    .tool-card-wrapper {
      padding: 20px 15px;
      min-height: 260px;
    }
    
    .icon-container {
      width: 90px;
      height: 90px;
      margin-bottom: 1rem;
    }
    
    .tool-icon {
      width: 65px;
      height: 65px;
    }
    
    .tool-card-front h3 {
      font-size: 1.3rem;
      margin-bottom: 8px;
    }
    
    .tool-card-front p {
      font-size: 0.9rem;
      line-height: 1.4;
    }
    
    .learn-more {
      font-size: 0.85rem;
      margin-top: 10px;
    }
    
    .preview-overlay {
      padding: 15px;
    }
    
    .preview-button {
      padding: 8px 16px;
      font-size: 0.9rem;
    }
  }
  
  @media (max-width: 480px) {
    .tool-card-wrapper {
      min-height: auto; /* Allow cards to size based on content */
      padding: 20px 15px;
    }
    
    .icon-container {
      width: 80px;
      height: 80px;
    }
    
    .tool-icon {
      width: 60px;
      height: 60px;
    }
  }
  
  /* Improve touch experience on iOS and other mobile browsers */
  @media (hover: none) {
    .tool-card-wrapper:hover {
      transform: none;
    }
    
    .tool-card-front .learn-more {
      opacity: 1;
      transform: none;
    }
    
    .tool-card-wrapper:active {
      transform: scale(0.98);
    }
  }`, "",{"version":3,"sources":["webpack://./src/home/Tools/toolCard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uDAAuD;IACvD;;kDAE8C;IAC9C,kCAA0B;YAA1B,0BAA0B;IAC1B,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,wCAAwC;IACxC;;kDAE8C;EAChD;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,oDAAoD;IACpD,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;EACd;;EAEA,mCAAmC;EACnC;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,+BAA+B;IAC/B,0CAA0C;EAC5C;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA,oBAAoB;EACpB;IACE,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;IACzB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA,kBAAkB;EAClB;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sDAAsD;IACtD,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA,gCAAgC;EAChC;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,yFAAyF;IACzF,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,oDAAoD;IACpD,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;IAC1C,oDAAoD;EACtD;;EAEA;IACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;IAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;EAC1C;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,qBAAqB;IACvB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,eAAe;MACf,iBAAiB;MACjB,cAAc;IAChB;;IAEA,gDAAgD;IAChD;MACE,UAAU;MACV,wBAAwB;IAC1B;;IAEA,2CAA2C;IAC3C;MACE,uCAAuC;IACzC;;IAEA;MACE,uCAAuC;IACzC;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,gBAAgB,EAAE,yCAAyC;MAC3D,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA,8DAA8D;EAC9D;IACE;MACE,eAAe;IACjB;;IAEA;MACE,UAAU;MACV,eAAe;IACjB;;IAEA;MACE,sBAAsB;IACxB;EACF","sourcesContent":[".tool-card-wrapper {\n    position: relative;\n    width: 100%;\n    max-width: 320px;\n    min-height: 320px;\n    border-radius: 18px;\n    background: rgba(255, 251, 230, 0.95);\n    padding: 20px;\n    text-align: center;\n    cursor: pointer;\n    overflow: hidden;\n    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1), \n                0 8px 15px rgba(0, 0, 0, 0.05),\n                0 1px 3px rgba(220, 202, 152, 0.3);\n    backdrop-filter: blur(5px);\n    transform-style: preserve-3d;\n    margin: 0 auto;\n  }\n  \n  .tool-card-wrapper:hover {\n    transform: translateY(-10px) scale(1.02);\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.14), \n                0 10px 20px rgba(0, 0, 0, 0.08),\n                0 2px 5px rgba(220, 202, 152, 0.4);\n  }\n  \n  .tool-card-wrapper::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 6px;\n    background: linear-gradient(90deg, #114040, #dcca98);\n    border-radius: 18px 18px 0 0;\n    opacity: 0.8;\n  }\n  \n  .tool-card-front {\n    z-index: 1;\n    position: relative;\n    padding: 10px 5px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n  }\n  \n  /* Icon container with background */\n  .icon-container {\n    width: 110px;\n    height: 110px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n    transition: transform 0.5s ease;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);\n  }\n  \n  .tool-card-wrapper:hover .icon-container {\n    transform: scale(1.1) translateY(-5px);\n  }\n  \n  .tool-icon {\n    width: 85px;\n    height: 85px;\n    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));\n    transition: transform 0.5s ease;\n  }\n  \n  .tool-card-front h3 {\n    font-size: 1.5rem;\n    color: #114040;\n    margin-bottom: 12px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    position: relative;\n    display: inline-block;\n  }\n  \n  .tool-card-front h3::after {\n    content: '';\n    position: absolute;\n    left: 50%;\n    bottom: -6px;\n    width: 40px;\n    height: 2px;\n    background: #dcca98;\n    transform: translateX(-50%);\n    transition: width 0.3s ease;\n  }\n  \n  .tool-card-wrapper:hover .tool-card-front h3::after {\n    width: 80px;\n  }\n  \n  .tool-card-front p {\n    font-size: 1rem;\n    color: #333;\n    margin-top: 8px;\n    line-height: 1.5;\n    flex-grow: 1;\n  }\n  \n  /* Learn more text */\n  .learn-more {\n    display: inline-block;\n    color: #114040;\n    font-size: 0.9rem;\n    font-weight: 600;\n    margin-top: 15px;\n    opacity: 0;\n    transform: translateY(10px);\n    transition: all 0.3s ease;\n    border-bottom: 1px dotted #dcca98;\n    padding-bottom: 2px;\n  }\n  \n  .tool-card-wrapper:hover .learn-more {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  \n  /* Hover overlay */\n  .tool-card-preview {\n    position: absolute;\n    inset: 0;\n    z-index: 2;\n    padding: 20px;\n    background: rgba(255, 255, 255, 0.98);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    animation: fadeIn 0.35s cubic-bezier(0.23, 1, 0.32, 1);\n    border-radius: 18px;\n    flex-direction: column;\n  }\n  \n  /* Preview overlay with button */\n  .preview-overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 20px;\n    background: linear-gradient(to top, rgba(255, 255, 255, 0.9) 70%, rgba(255, 255, 255, 0));\n    display: flex;\n    justify-content: center;\n  }\n  \n  .preview-button {\n    background: linear-gradient(90deg, #114040, #195e5e);\n    color: #dcca98;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 30px;\n    font-weight: 600;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    letter-spacing: 0.5px;\n  }\n  \n  .preview-button:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);\n    background: linear-gradient(90deg, #195e5e, #114040);\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; transform: scale(0.96); }\n    to   { opacity: 1; transform: scale(1); }\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 1200px) {\n    .tool-card-wrapper {\n      max-width: 100%;\n    }\n  }\n  \n  @media (max-width: 991px) {\n    .tool-card-wrapper {\n      min-height: 300px;\n      padding: 25px 20px;\n    }\n    \n    .icon-container {\n      width: 100px;\n      height: 100px;\n      margin-bottom: 1.2rem;\n    }\n    \n    .tool-icon {\n      width: 75px;\n      height: 75px;\n    }\n    \n    .tool-card-front h3 {\n      font-size: 1.4rem;\n      margin-bottom: 10px;\n    }\n    \n    .tool-card-front p {\n      font-size: 0.95rem;\n    }\n    \n    .preview-button {\n      padding: 8px 18px;\n      font-size: 0.95rem;\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .tool-card-wrapper {\n      max-width: 100%;\n      min-height: 280px;\n      margin: 0 auto;\n    }\n    \n    /* Make hover effects show on touch for mobile */\n    .tool-card-front .learn-more {\n      opacity: 1;\n      transform: translateY(0);\n    }\n    \n    /* Adjust hover effects for touch devices */\n    .tool-card-wrapper:hover {\n      transform: translateY(-5px) scale(1.01);\n    }\n    \n    .tool-card-wrapper:hover .icon-container {\n      transform: scale(1.05) translateY(-3px);\n    }\n  }\n  \n  @media (max-width: 600px) {\n    .tool-card-wrapper {\n      padding: 20px 15px;\n      min-height: 260px;\n    }\n    \n    .icon-container {\n      width: 90px;\n      height: 90px;\n      margin-bottom: 1rem;\n    }\n    \n    .tool-icon {\n      width: 65px;\n      height: 65px;\n    }\n    \n    .tool-card-front h3 {\n      font-size: 1.3rem;\n      margin-bottom: 8px;\n    }\n    \n    .tool-card-front p {\n      font-size: 0.9rem;\n      line-height: 1.4;\n    }\n    \n    .learn-more {\n      font-size: 0.85rem;\n      margin-top: 10px;\n    }\n    \n    .preview-overlay {\n      padding: 15px;\n    }\n    \n    .preview-button {\n      padding: 8px 16px;\n      font-size: 0.9rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .tool-card-wrapper {\n      min-height: auto; /* Allow cards to size based on content */\n      padding: 20px 15px;\n    }\n    \n    .icon-container {\n      width: 80px;\n      height: 80px;\n    }\n    \n    .tool-icon {\n      width: 60px;\n      height: 60px;\n    }\n  }\n  \n  /* Improve touch experience on iOS and other mobile browsers */\n  @media (hover: none) {\n    .tool-card-wrapper:hover {\n      transform: none;\n    }\n    \n    .tool-card-front .learn-more {\n      opacity: 1;\n      transform: none;\n    }\n    \n    .tool-card-wrapper:active {\n      transform: scale(0.98);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
